export default [
  {
    path: "/raporrandevu",
    name: "raporrandevu",
    component: () => import("./index.vue"),
    meta: {
      public: false,
      title: "raporrandevu.Baslik",
      yetki: { k: [2001302] },
    },
  },
]
